import React from 'react';
import { Row, Col, message, Layout,  Select,Button,Icon } from 'antd';
import TableWrapper from "../elements/TableWrapper";
import img from '../../assets/img/Illustratiion.png';
import MiCompAPI from '../../util/api';
const { Content } = Layout;
const { Option } = Select;
class ManageReports extends React.Component {
    constructor(props) {
        super(props);
        this.columns = [{
            title: 'Report Name',
            dataIndex: 'menuName',
            width: '30%'
        },
        {
            title: 'Role',
            dataIndex: 'isRole',
            width: '70%',
            render: (text, record) => <fieldset style={{ height: '33px', margin: "-10px", width: "300px" }}>
            {record['is_admin_have_right']?
            <Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} mode='multiple'   onChange={this.UserRoleChange.bind(this, record)} defaultValue={record['isRole']?record['isRole']:undefined} className="mi_input" placeholder="Please Select">
                {this.state.getroles.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
            </Select>: <Select  suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} mode='multiple'   onChange={this.UserRoleChange.bind(this, record)} defaultValue={record['isRole']?record['isRole']:undefined} className="mi_input" placeholder="Please Select">
                {this.state.roles.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
            </Select>}
            </fieldset>
        }];
        this.state = {
            getroles: [],
            roles:[],
            reports: [],
            loading: false
        }
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    UserRoleChange = (record, e) => {
        this.setState({
            reports: this.state.reports.map(x => {
                if (x.menuId === record.menuId) {
                    return { ...x, isRole: e }
                }
                else {
                    return x
                }
            })
        })
    }
    componentDidMount = () => {
        this.getClientMasters();
        this.getManageReports();
        this.GetComplianceRole();
    }
    Submitt=()=>{
        this.api.invoke(
            "SaveAndUpdateMenus",
            "post",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        message.destroy();
                        message.success(data.statusMessage, 3);
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            },this.state.reports
        );
    }
    getManageReports = () => {
        this.setState({
            loading: true,
        })
        this.api.invoke(
            "GetALLReportMenus",
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.setState({
                            reports: data.data
                            , loading: false,
                        })
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            }
        );
    }
    getClientMasters() {
        this.api.invoke(
            "GetMasters",
            "post",
            (data, success) => {
                if (success) {
                    this.setState({
                        getroles: data.getroles
                    });
                }
            },
            ["GETALLROLES"]
        );
    }
    GetComplianceRole = () => {
        this.setState({
            loading: true,
        })
        this.api.invoke(
            "GetComplianceRole",
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.setState({
                            roles: data.data
                            , loading: false,
                        })
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            }
        );
    }
    render() {
        return (
            <Content>
                <div className="mi_main_div">
                    <Row span={24}>
                        <Col span={24}>
                            <TableWrapper rowKey="menuId" title="Manage Reports"
                                bordered={true} columns={this.columns} data={this.state.loading ? null : this.state.reports} loading={this.state.loading}
                                search={true}
                            />
                        </Col>
                    </Row>
                    <Row span={24} style={{ marginTop: '20px' }}>
                        <Col span={7} ></Col>
                        <Col span={3} >
                        </Col>
                        <Col span={5} >
                            <Button onClick={this.Submitt}  className="submit-button"   type="primary">
                                Submit
                    </Button>
                        </Col>
                        <Col span={2} >
                        </Col>
                        <Col span={7} >
                            <img alt="example" style={{ width: 105, marginBottom: '-20px', float: 'right' }} src={img} />
                        </Col>
                    </Row>
                </div>
            </Content>
        );
    }
}
export default ManageReports;
